class Module {
    async load(node = false) {
        if (this._wasm === undefined) {
            this._wasm = await (node
                ? import("@emurgo/cardano-serialization-lib-nodejs/cardano_serialization_lib")
                : import("@emurgo/cardano-serialization-lib-browser/cardano_serialization_lib"));
        }
        return this._wasm;
    }
    get CardanoWasm() {
        return this._wasm;
    }
}
// need this otherwise Wallet's flow type isn't properly exported
export const RustModule = new Module();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVzdExvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9ydXN0TG9hZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sTUFBTTtJQUdWLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBZ0IsS0FBSztRQUM5QixJQUFJLElBQUksQ0FBQyxLQUFLLEtBQUssU0FBUyxFQUFFO1lBQzVCLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUk7Z0JBQ3RCLENBQUMsQ0FBQyxNQUFNLENBQUMsb0VBQW9FLENBQUM7Z0JBQzlFLENBQUMsQ0FBQyxNQUFNLENBQUMscUVBQXFFLENBQUMsQ0FBQyxDQUFBO1NBQ25GO1FBQ0QsT0FBTyxJQUFJLENBQUMsS0FBTSxDQUFBO0lBQ3BCLENBQUM7SUFFRCxJQUFJLFdBQVc7UUFDYixPQUFPLElBQUksQ0FBQyxLQUFNLENBQUE7SUFDcEIsQ0FBQztDQUNGO0FBRUQsaUVBQWlFO0FBQ2pFLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBVyxJQUFJLE1BQU0sRUFBRSxDQUFBIn0=